import React from 'react';
import GradientWrapper from './GradientWrapper';
interface GradientHintCardProps {
  children: ReactNode;
  className?: string;
}
const GradientHintCard: React.FC<GradientHintCardProps> = ({
  children,
  className = ''
}) => {
  return <GradientWrapper radius="8px" paddingPx={1} data-id="element-1247">
      <div className={`bg-white p-3 rounded-lg shadow-sm ${className}`} data-id="element-1248">
        {children}
      </div>
    </GradientWrapper>;
};
export default GradientHintCard;